import { render } from "./FilterCompany.vue?vue&type=template&id=44827adc&ts=true"
import script from "./FilterCompany.vue?vue&type=script&lang=ts"
export * from "./FilterCompany.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__